import Vue from 'vue'
import Vuex from 'vuex'
import Olympiads from './modules/olympiads/index'
import ContentManager from './modules/content-manager/index'
import Workspace from './modules/workspace/index'
import Chats from './modules/chats/index'
import Contacts from './modules/contacts/index'
import Content from './modules/content/index'
import CurrentUserModule from './modules/current-user/index'
import Dicts from './modules/dicts/index'
import Education from './modules/education/index'
import EducationStudentsManagement from './modules/education-managment/index'
import Notifications from './modules/notifications/index'
import Socket from './modules/socket/index'
import Statistic from './modules/statistics/index'
import Test from './modules/test/index'
import Toasts from './modules/toasts/index'
import Training from './modules/training/index'
import User from './modules/user/index'
import Users from './modules/users/index'
import Profession from './modules/profession/index'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    olympiads: {
      namespaced: true,
      ...Olympiads
    },
    contentManager: {
      namespaced: true,
      ...ContentManager
    },
    workspace: {
      namespaced: true,
      ...Workspace
    },
    chats: {
      namespaced: true,
      ...Chats
    },
    contacts: {
      namespaced: true,
      ...Contacts
    },
    content: {
      namespaced: true,
      ...Content
    },
    currentUser: {
      namespaced: true,
      ...CurrentUserModule
    },
    dicts: {
      namespaced: true,
      ...Dicts
    },
    education: {
      namespaced: true,
      ...Education
    },
    educationStudentsManagement: {
      namespaced: true,
      ...EducationStudentsManagement
    },
    notifications: {
      namespaced: true,
      ...Notifications
    },
    socket: {
      namespaced: true,
      ...Socket
    },
    statistics: {
      namespaced: true,
      ...Statistic
    },
    test: {
      namespaced: true,
      ...Test
    },
    toasts: {
      namespaced: true,
      ...Toasts
    },
    training: {
      namespaced: true,
      ...Training
    },
    user: {
      namespaced: true,
      ...User
    },
    users: {
      namespaced: true,
      ...Users
    },
    profession: {
      namespaced: true,
      ...Profession
    }
  },

  state: {},

  mutations: {},

  actions: {
    initialize: ({ dispatch }) => Promise.all([
      dispatch('currentUser/fetchCurrentUser'),
      dispatch('dicts/fetchOrganizations')
    ])
  },

  getters: {}
})
